import type { RouteRecordRaw } from 'vue-router';

import { wrapRuntimeImport } from '@/shared/helpers/async.helpers';
import { makePermissionMeta } from '@/shared/helpers/permissions.helpers';

import { captureSlackCallback } from './screens/connected-apps/connect';

export const AdminIntegrationsRoutes: RouteRecordRaw[] = [
    {
        path: '',
        component: wrapRuntimeImport(() => import('./screens/landing.vue')),
        meta: { admin: true }
    },
    {
        path: 'webhooks',
        component: wrapRuntimeImport(() => import('./screens/webhooks.vue')),
        meta: { admin: true, ...makePermissionMeta('sales') }
    },
    {
        path: 'connected-apps',
        component: wrapRuntimeImport(() => import('./screens/connected-apps.vue')),
        meta: { admin: true }
    },
    {
        // Registered with Slack as the OAuth redirect URL; the API builds it from SPA_URI.
        path: 'connected-apps/slack/callback',
        component: wrapRuntimeImport(() => import('./screens/connected-apps/slack-callback.vue')),
        meta: { admin: true },
        beforeEnter: captureSlackCallback
    },
    {
        path: 'webhooks/:id/deliveries',
        component: wrapRuntimeImport(() => import('./screens/webhooks/deliveries.vue')),
        meta: { admin: true, ...makePermissionMeta('sales') }
    }
];
